import React, { useState, useEffect, useRef } from "react";

const MediaUpload = ({ label, placeholder, value, name, previewEnabled, onChange = () => {} }) => {
  const [file, setFile] = useState(null);
  const imgRef = useRef(value);

  useEffect(() => {
    onChange(file ? file : value);
    if (file && previewEnabled && imgRef.current) {
      imgRef.current.src = URL.createObjectURL(file);
    }
  }, [file]);

  useEffect(() => {
    if (imgRef.current && typeof imgRef.current !== "object") {
      imgRef.current = value;
    }
  }, [value]);

  return (
    <>
      {label && (
        <label className="mmmbaa_label">
          {label}{" "}
          {value && !["{}", "null"].includes(value) && (
            <a
              href={typeof value === "string" ? value : file ? URL.createObjectURL(file) : value}
              target="_blank"
              rel="noreferrer"
              download={typeof value === "string" ? value?.split("/").pop : file ? URL.createObjectURL(file)?.value?.split("/").pop : value}
              className="mmm_download_icon"
              onClick={() => {
                const src = imgRef.current.src || imgRef.current;
                if (!["{}", "null"].includes(src)) {
                  window.open(typeof value === "string" ? value : file ? URL.createObjectURL(file) : value);
                }
              }}
            >
              <svg fill="#000000" width="20px" height="20px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <title>download</title>
                <path d="M232 64L280 64 280 214 277 270 300 242 356 189 388 221 256 353 124 221 156 189 212 242 235 270 232 214 232 64ZM64 400L448 400 448 448 64 448 64 400Z" />
              </svg>
            </a>
          )}
        </label>
      )}
      <input className={` ${name} input_file`} type="file" onChange={(e) => setFile(e.target.files[0])} placeholder={placeholder} />
      {previewEnabled && file && (
        <div className="mmmbaa_attach_preview">
          <img ref={imgRef} src="" />
        </div>
      )}
      {/* {value && (
        <div className="mmmbaa_attach_preview">
          <img src={value} />
        </div>
      )} */}
    </>
  );
};

export default MediaUpload;
